import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { ParameterManagementTypeService } from './tooltype.service'
import { ToolTypeDescriptionService, ToolTypeService, ControlPanelServiceDescription } from '../../camtl/camtl.service';

@Component({
  selector: 'app-parameter-management',
  templateUrl: './parameter-management.component.html',
  // styleUrls: ['./parameter-management.component.scss']
  host: { 'style': 'width: 100%' },
})
export class ParameterManagementComponent implements OnInit {

  constructor(public router: Router,
    private ParameterManagementTypeService: ParameterManagementTypeService,
    private ToolTypeDescriptionService: ToolTypeDescriptionService,

  ) { }
  private Id: any;
  private FurnishedEquipDescription: any;
  // Control Panel, Weldgun, Furnished Equip are not needed for relase 1.0 //
  tabs = [
    // {
    //   title: "Control Panel",
    //   route: "ControlPanel"
    // },
    // {
    //   title: "Furnished Equipment",
    //   route: "FurnishedEquipment"
    // },
    {
      title: "Kit",
      route: "Kit",
    },
    {
      title: "Tool",
      route: "Tool",
    },
    // {
    //   title: "Weldgun",
    //   route: "Weldgun",
    // },
  ]

  FunrishedEquipmentHandler = () => {
    console.log(this.FurnishedEquipDescription + "Hello")
    if (this.handleSelect)
      return this.ToolTypeDescriptionService + "It worked"


  }


  ngOnInit() {

    this.router.events.subscribe((val) => {
      this.setSelectedTab();
    });

    this.setSelectedTab();
  }

  //handle tab change when changing URL via browser / refreshing the page
  setSelectedTab() {
    var componentUrl = this.router.url.split("/").pop();
    this.tabs.map(function (tab) {
      tab["selected"] = false;
    });

    for (var i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].route === componentUrl) {
        this.tabs[i]["selected"] = true;
        return;
      }
    }
  }

  selectedId: string = "";


  public handleSelect({ index }): boolean {
    this.router.navigate(["/MESC/CAMTL/Administration/ParameterManagement/" + this.tabs[index].route]);
    return false;
  }

}